var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { styled } from '@mui/material/styles';
import MuiCard from '@mui/material/Card';
var Card = styled(MuiCard)(function (_a) {
    var theme = _a.theme, filled = _a.filled, sx = _a.sx, width = _a.width, height = _a.height;
    return (__assign({ display: 'flex', flexDirection: 'column', alignSelf: 'center', width: width || '100%', height: height || 'auto', boxSizing: 'border-box', padding: theme.spacing(4), gap: theme.spacing(2), backgroundColor: filled ? theme.palette.primary.main : theme.palette.background.paper, border: filled ? 'none' : "1px solid ".concat(theme.palette.divider), color: filled ? theme.palette.primary.contrastText : theme.palette.text.primary }, sx));
});
export default Card;
